module.exports = __webpack_public_path__ + "static/media/digital_policy.4ffb1b63.svg";